"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Middleware = exports.ActingTenant = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const Error = __importStar(require("./error"));
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Tenant';
class ActingTenant extends effect_1.Context.Tag(`${exports.NAMESPACE}.ActingTenant`)() {
}
exports.ActingTenant = ActingTenant;
class Middleware extends platform_1.HttpApiMiddleware.Tag()(`${exports.NAMESPACE}.Middleware`, {
    provides: ActingTenant,
    failure: effect_1.Schema.Union(Error.NotAuthorizedErrorFromProtocol, Error.InternalServerErrorFromProtocol),
    security: {
        tenant: platform_1.HttpApiSecurity.apiKey({ key: 'x-culligan-tenant-id' }).pipe(platform_1.HttpApiSecurity.annotate(platform_1.OpenApi.Description, 'The ID of the tenant you want to run this request for')),
    },
}) {
}
exports.Middleware = Middleware;
//# sourceMappingURL=tenant.js.map